import { db } from '../config/firebase';
import { collection, query, where, orderBy, onSnapshot, updateDoc, doc, deleteDoc } from 'firebase/firestore';

/**
 * Subscribe to user notifications
 * @param {string} userId - User ID to subscribe to
 * @param {function} callback - Callback function to receive notifications
 * @returns {function} Unsubscribe function
 */
export const subscribeToNotifications = (userId, callback) => {
  if (!userId) {
    console.error('User ID is required to subscribe to notifications');
    return () => {};
  }

  const notificationsRef = collection(db, 'notifications');
  const q = query(
    notificationsRef,
    where('userId', '==', userId),
    orderBy('createdAt', 'desc')
  );

  return onSnapshot(q, (snapshot) => {
    const notifications = [];
    snapshot.forEach((doc) => {
      notifications.push({
        id: doc.id,
        ...doc.data()
      });
    });
    callback(notifications);
  }, (error) => {
    console.error('Error subscribing to notifications:', error);
  });
};

/**
 * Mark notification as read
 * @param {string} notificationId - Notification ID to mark as read
 */
export const markNotificationAsRead = async (notificationId) => {
  try {
    const notificationRef = doc(db, 'notifications', notificationId);
    await updateDoc(notificationRef, {
      read: true,
      readAt: new Date().toISOString()
    });
    return { success: true };
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Delete notification
 * @param {string} notificationId - Notification ID to delete
 */
export const deleteNotification = async (notificationId) => {
  try {
    const notificationRef = doc(db, 'notifications', notificationId);
    await deleteDoc(notificationRef);
    return { success: true };
  } catch (error) {
    console.error('Error deleting notification:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Get unread notification count
 * @param {array} notifications - Array of notifications
 * @returns {number} Count of unread notifications
 */
export const getUnreadCount = (notifications) => {
  return notifications.filter(n => !n.read).length;
};
